import { Reward, RewardPreferenceCategory } from 'src/app/utility/model/reward';

export interface RewardsState {
  rewards: Rewards | any;
  loading: boolean;
  error: string | null;
  filtersCount?: number;
  params: RewardParams;
  rewardQty: RewardQtyState;
  spinner: boolean;
}

export const initialRewardsState: RewardsState = {
  rewards: {},
  loading: true,
  error: null,
  filtersCount: 0,
  params: {},
  rewardQty: {
    rewardQuantities: [],
  },
  spinner: false,
};

export interface RewardState {
  reward: Reward | any;
  loading: boolean;
  error: any;
}

export const initialRewardState: RewardState = {
  reward: null,
  loading: false,
  error: null,
};

export interface Rewards {
  map(arg0: (item: any) => any): unknown;
  count?: number | null;
  next?: string | null;
  previous?: string | null;
  results?: Reward[];
}

export interface RewardParams {
  category?: string;
  sub_category?: string;
  to_points?: number;
  sort?: string;
  ordering?: string;
  page?: number;
  page_size?: number;
  search?: string | null;
  fields?: string;
  preferred_sub_category?: boolean;
  favorites?: boolean;
  rating?: any;
}

export interface RewardsCatAndSubCatPreferenceState {
  rewardCategories: RewardPreferenceCategory[] | null;
  loading: boolean;
  error: any;
  params: RewardSubCategoryPreferenceParams;
}

export const initialRewardsCatAndSubCatPreferenceState: RewardsCatAndSubCatPreferenceState =
  {
    rewardCategories: [],
    loading: false,
    error: null,
    params: {},
  };
export interface RewardQty {
  rewardId: number | null;
  qty: number;
}

export interface RewardQtyState {
  rewardQuantities: RewardQty[];
}

export interface RewardSubCategoryPreferenceParams {
  level?: string;
}
